import { combineReducers, configureStore } from "@reduxjs/toolkit";
import categorySlice from './slices/categorySlice'
import categoriesSlice from './slices/categoriesSlice'
import productSlice from './slices/productSlice';
import productsSlice from './slices/productsSlice';
import pageSlice from './slices/pageSlice'
import sliderSlice from './slices/sliderSlice'
import slidersSlice from './slices/slidersSlice'
import cartSlice from './slices/cartSlice'
import checkoutSlice from "./slices/checkoutSlice";
import userSlice from "./slices/userSlice";
import authSlice from './slices/authSlice'
import metaSlice from './slices/metaSlice';
import brandSlice from './slices/brandSlice'
import brandsSlice from './slices/BrandsSlice'
import menuSlice from './slices/menuSlice'
import orderSlice from './slices/orderSlice'
const reducer = combineReducers({
    categoryState: categorySlice,
    categoriesState: categoriesSlice,
    productState: productSlice,
    productsState: productsSlice,
    pageState: pageSlice,
    sliderState: sliderSlice,
    slidersState: slidersSlice,
    cartState: cartSlice,
    checkoutState: checkoutSlice,
    userState: userSlice,
    authState: authSlice,
    metaState: metaSlice,
    brandState: brandSlice,
    brandsState: brandsSlice,
    menuState: menuSlice,
    cartState: cartSlice,
    orderState: orderSlice,
})

const store = configureStore({
    reducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        })
});

export default store;